import { Factory } from '../Factory';
import { Service } from '../Service';
import { IConfigService } from '../config';
import { IHttpWrapperService } from '../http';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class BillingService extends Service<any> {
  private configService: IConfigService;
  private httpService: IHttpWrapperService;

  constructor(resource: any, rootScope: IRootScope, httpService: IHttpWrapperService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
    super({resource, rootScope, resourceWrapperService});

    this.httpService = httpService;
    this.configService = configService;

    let projectBillingResource = this.resource(`${configService.getServerBaseUrlForResource()}/billing/project/:projectId`,
      {projectId: '@projectId'}
    );

    this.itemResource = this.resourceWrapperService.WrapActions(projectBillingResource);
  }

  public GetByCurrentBillingCycle(projectId: string) {
    let url = `${this.configService.getServerBaseUrl()}/billing/project/${projectId}`;

    return this.httpService.$http({
      method: 'GET',
      url: url
    });
  }

  public GetByDateRange(projectId: string, startDate: Date, endDate: Date) {
    let url = `${this.configService.getServerBaseUrl()}/billing/project/${projectId}/start/${startDate.toISOString().substring(0, 10)}/end/${endDate.toISOString().substring(0, 10)}`;

    return this.httpService.$http({
      method: 'GET',
      url: url
    });
  }

  public GetCSV(projectId: string, startDate: Date, endDate: Date) {
    let url = `${this.configService.getServerBaseUrl()}/billing/csv/project/${projectId}/start/${startDate.toISOString().substring(0, 10)}/end/${endDate.toISOString().substring(0, 10)}`;

    return this.httpService.$http({
      method: 'GET',
      url: url
    });
  }
}

frontendApp.factory("BillingService", ["$resource", "$rootScope", "HttpService", "ConfigService", "ResourceWrapperService", Factory.Create(BillingService)]);
